<script setup>
import { useAuth } from '@/composables/useAuth.js'
const { user, signOut } = useAuth()

async function onSignOut() {
  await signOut()
  window.location.href = '/login'
}
</script>

<template>
  <div class="user-menu" v-if="user">
    <div class="avatar" :title="user.email">
      <img v-if="user.avatar_url" :src="user.avatar_url" alt="" />
      <span v-else>{{ (user.display_name || user.email || '?').slice(0, 1).toUpperCase() }}</span>
    </div>
    <div class="meta">
      <div class="name">{{ user.display_name || user.email }}</div>
      <div class="tier">{{ user.tier }}</div>
    </div>
    <button class="signout" @click="onSignOut">Sign out</button>
  </div>
  <div v-else class="signed-out">
    <a href="/login">Sign in</a>
  </div>
</template>

<style scoped>
.user-menu {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 8px;
  border-top: 1px solid var(--border);
  margin-top: 16px;
}
.avatar {
  width: 28px;
  height: 28px;
  border-radius: 6px;
  background: var(--border);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 700;
  color: var(--ink);
  flex-shrink: 0;
  overflow: hidden;
}
.avatar img { width: 100%; height: 100%; object-fit: cover; }
.meta { flex: 1; min-width: 0; }
.name {
  font-size: 13px;
  font-weight: 500;
  color: var(--ink);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.tier {
  font-size: 11px;
  color: var(--muted);
  text-transform: uppercase;
  letter-spacing: 0.04em;
}
.signout {
  background: none;
  border: 1px solid var(--border);
  border-radius: 4px;
  padding: 4px 10px;
  font-size: 13px;
  font-weight: 500;
  white-space: nowrap;
  cursor: pointer;
  color: var(--muted);
  flex-shrink: 0;
}
.signout:hover { color: var(--ink); border-color: var(--ink); }
.signed-out {
  padding: 10px 8px;
  border-top: 1px solid var(--border);
  margin-top: 16px;
  font-size: 13px;
}
.signed-out a { color: var(--muted); text-decoration: none; }
.signed-out a:hover { color: var(--ink); }
</style>
